module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "activityCalendar"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.showCloseButton) ? _c('button', {
    staticClass: "closeButton",
    on: {
      "click": function($event) {
        _vm.toggleCalendarOnTop()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "card-title text-sm-center m-b-2"
  }, [_vm._v(_vm._s(_vm.t('Calendar')))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('pre-booking')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    attrs: {
      "id": "calendar"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fbe1549a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbe1549a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/ActivityCalendar.vue
// module id = 811
// module chunks = 3